import React from 'react'
import { Form } from 'react-bootstrap'

function InputUsername({ value, onChange, className = '', ...other }) {
  const regex = /^[a-z0-9._]+$/

  return (
    <Form.Control
      type="text"
      className={`form-control ${className}`}
      value={value}
   
      onChange={(e) => {
        if (e.target.value.match(regex)) {
          onChange(e)
        } else {
          if (e.target.value.length < 1) {
            onChange(e)
          }
        }
      }}
      {...other}
    />
  )
}

export default InputUsername
